module.exports = __webpack_public_path__ + "static/media/mn17.066ce2d0.jpeg";